import React from "react";
import { Helmet } from "react-helmet";
import Card from "../components/Card"; // Assuming your Card component is imported

function ContactUs() {
  return (
    <div>
      <Helmet>
        <title>Contact Us | PROPS Yacht Consulting</title>
        <meta name="description" content="Contact Us page of PROPS Yacht Consulting" />
      </Helmet>
      <Card
        title="Contact Us"
        content={[
          <div className="contact-container">
            <ul className="contact-list">
              <li key="phone1" style= {{marginTop: "20px", marginBottom: "20px"}}>
                <strong>Phone 1:</strong>{" "}
                <a href="tel:+33609751406">+33 6 09 75 1406</a>
              </li>
              <li key="phone2" style= {{marginBottom: "20px"}}>
                <strong>Phone 2:</strong>{" "}
                <a href="tel:+971585191406">+971 58 519 1406</a>
              </li>
              <li key="email">
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:arnaud@props-yachtconsulting.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  arnaud@props-yachtconsulting.com
                </a>
              </li>
            </ul>
          </div>,
        ]}
        height="200px"
        textPosition={{ top: "10px", left: "550px", font: "10px", color: "black", textAlign: "center"}}
        //Mobile styles
        mobileHeight="200px"
        mobileTextPosition={{ top: "10px", left: "50px", font: "10px", color: "black", textAlign: "center"}}
      />
    </div>
  );
}

export default ContactUs;
